module.exports = __webpack_public_path__ + "static/media/cardIllustrationFilled.25272f67.svg";